// extracted by mini-css-extract-plugin
export default {"header":"ScrollTable_header__1oDJ-","scrolled":"ScrollTable_scrolled__5Jzfu"};